<script>
import {bankPage as nav } from "../../../antd-pro/navigation/setting/page"

export default {
    props: {
        hash: {
            required: true
        }
    },
    computed: {
        navigation() {
            return nav
        },
        current() {
            return this.getRoute()
        },
        prevUrl() {
            return window.location.search.replace("?h=", '');
        }
    },
    data: () => ({
        loading: false,
        item: {}
    }),
    created() {
        if (this.hash !== null) {
            this.getItem()
        }
    },
    methods: {
        getItem() {
            this.loading = true
            this.$http.get(this.routeUri('api.banks.show', { 'bank': this.hash}))
            .then((r) => this.item = r.data)
            .catch((e) => this.handleXhrError(e))
            .finally(() => this.loading = false)
        },
        back() {
            window.location.href = this.routeUri("admin.setting.bank")
        },
    },
}
</script>
<template>
    <div>
        <a-page-header :ghost="false" :title="item.name" @back="back">
            <a-card type="inner" size="small">
                <a-row type="flex">
                    <a-col :span="24">
                        <a-descriptions bordered>
                            <a-descriptions-item label="Bank">
                                <strong>{{ item.name }}</strong>
                            </a-descriptions-item>
                            <a-descriptions-item label="Kode">
                                <strong>{{ item.code }}</strong>
                            </a-descriptions-item>
                            <a-descriptions-item label="Nomor Telepon">
                                <strong>{{ item.phone }}</strong>
                            </a-descriptions-item>
                            <a-descriptions-item label="Alamat">
                                <strong>{{ item.address }}</strong>
                            </a-descriptions-item>
                            <a-descriptions-item label="Nama PIC">
                                <strong>{{ item.pic_name }}</strong>
                            </a-descriptions-item>
                            <a-descriptions-item label="Kontak PIC">
                                <strong>{{ item.pic_contact }}</strong>
                            </a-descriptions-item>
                        </a-descriptions>
                    </a-col>
                </a-row>
            </a-card>

            <template #footer>
                <a-menu mode="horizontal" :selected-keys="[ current ]">
                    <a-menu-item v-for="menu in navigation" :key="menu.route">
                        <a :href="routeUri(menu.route) + '?id=' + hash">
                            <a-icon :type="menu.icon"/>
                            {{ menu.text }}
                        </a>
                    </a-menu-item>
                </a-menu>
            </template>
        </a-page-header>
        <slot name="bank-content"></slot>
    </div>
</template>
